import { createPreviewInvitationData } from "@anggunpraya-templates/base/app/data/preview-invitation";

export const {
  eventGuest: EVENT_GUEST,
  eventDetail: EVENT_DETAIL,
} = createPreviewInvitationData({
  templateCode: "AP-006",
  packageName: "Celebration",
});
